<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.tab" @input="load">
          <b-tab>
            <template slot="title">
              {{ $t('all') }}
              <small v-if="!countLoading">({{ count[0] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab v-if="!client">
            <template slot="title">
              {{ $t('isDemo') }}
              <small v-if="!countLoading">({{ count[1] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab v-if="!client">
            <template slot="title">
              {{ $t('isRental') }}
              <small v-if="!countLoading">({{ count[2] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab v-if="!client">
            <template slot="title">
              {{ $t('availableForRent') }}
              <small v-if="!countLoading">({{ count[3] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab v-if="!client">
            <template slot="title">
              {{ $t('clientOwned') }}
              <small v-if="!countLoading">({{ count[4] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 5 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('unowned') }}
              <small v-if="!countLoading">({{ count[5] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 6 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('isSpam') }}
              <small v-if="!countLoading">({{ count[6] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 7 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('isBrandName') }}
              <small v-if="!countLoading">({{ count[7] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 8 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('isInboundCharge') }}
              <small v-if="!countLoading">({{ count[8] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 9 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('isCommit') }}
              <small v-if="!countLoading">({{ count[9] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 10 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('numberRandom') }}
              <small v-if="!countLoading">({{ count[10] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 11 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('numberHidden') }}
              <small v-if="!countLoading">({{ count[11] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 12 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('suspectedBlocked') }}
              <small v-if="!countLoading">({{ count[12] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.tab !== 13 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('skipSpamCheck') }}
              <small v-if="!countLoading">({{ count[13] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <template v-if="!client" v-slot:tabs-end>
            <b-dropdown :text="$t('more')" variant="transparent">
              <b-dropdown-item @click="filterFormModel.tab = 6">
                {{ $t('isSpam') }}
                <small v-if="!countLoading">({{ count[6] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.tab = 7">
                {{ $t('isBrandName') }}
                <small v-if="!countLoading">({{ count[7] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.tab = 8">
                {{ $t('isInboundCharge') }}
                <small v-if="!countLoading">({{ count[8] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.tab = 9">
                {{ $t('isCommit') }}
                <small v-if="!countLoading">({{ count[9] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.tab = 10">
                {{ $t('numberRandom') }}
                <small v-if="!countLoading">({{ count[10] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.tab = 11">
                {{ $t('numberHidden') }}
                <small v-if="!countLoading">({{ count[11] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.tab = 12">
                {{ $t('suspectedBlocked') }}
                <small v-if="!countLoading">({{ count[12] }})</small>
              </b-dropdown-item> 
              <b-dropdown-item @click="filterFormModel.tab = 13">
                {{ $t('skipSpamCheck') }}
                <small v-if="!countLoading">({{ count[13] }})</small>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="type" :options="[
                {value: null, text: $t('all')},
                {value: 'isPackage', text: $t('isPackage')}
                ]"></form-select>
            <network-select :model="filterFormModel" class="mr-1 mb-1"></network-select>
            <host-select v-if="!host && !client" :model="filterFormModel" attribute="host"
                         class="mr-1 mb-1"></host-select>
            <gateway-select :model="filterFormModel" class="mr-1 mb-1" attribute="gateway"></gateway-select>
            <client-select v-if="!client" :model="filterFormModel" attribute="client" @change="search" :isFilter="true"
                           :place-holder="$t('selectClient')" class="mr-1 mb-1"></client-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>

      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting"
             v-if="['owner', 'admin', 'account', 'operationsManager', 'tech', 'am'].includes($store.state.user.role)">
          <div class="row">
            <div class="col">
              <div class="c-sorting__btn">
                <b-dropdown :disabled="!checkedItems.length" id="dropdown-left"
                            :text="$t('selected', [checkedItems.length])" variant="secondary"
                            size="sm">
                  <b-dropdown-item @click="showDelete = true">{{ $t('delete') }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="col c-sorting__right" v-if="!hiddenCSortingFeature">
              <div class="c-sorting__btn">
                <check-phone-number/>
                <import
                    v-if="['owner', 'admin', 'account', 'operationsManager', 'tech', 'am'].includes($store.state.user.role)"></import>
                <export
                    v-if="['owner', 'admin', 'account', 'operationsManager', 'tech'].includes($store.state.user.role)"
                    :filter="filterFormModel" :totalCount="itemCount"/>
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            <table-config ref="tableConfig" :type="$t('phoneNumbers')"
                          :firstItemOfPage="firstItemOfPage" :lastItemOfPage="lastItemOfPage"
                          :itemCount="itemCount" @change="loadTableConfig"/>
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title check-row">
            <div class="col-lg-3 check-column">
              {{ $t('phoneNumber') }}
              <b-form-checkbox v-if="['owner', 'admin', 'tech', 'account'].includes($store.state.user.role)"
                               :class="`check-form ${checkedItems.length === items.length ? '' : 'hide'}`"
                               v-model="selectAll" @change="select"></b-form-checkbox>
            </div>
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-3">{{ $t('status') }}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row check-row" v-for="item in items" :key="item._id">
            <div class="col-lg-3 check-column">
              <b-form-checkbox
                  v-if="['owner', 'admin', 'tech', 'account'].includes($store.state.user.role) || ($store.state.user.role === 'am' && !item.isRental && item.client && $store.state.user._id === item.client.account)"
                  :class="`check-form ${checkedItems.find(checkedItem => checkedItem._id === item._id) ? '' : 'hide'}`"
                  :value="item" v-model="checkedItems" @change="updateCheckAll"></b-form-checkbox>
              <div>
                <b>{{ $t('phoneNumber') }}: </b>
                <span>{{ item.number }}</span>
              </div>
              <div v-if="item.name">
                <b>{{ $t('name') }}: </b>
                <span>{{ item.name }}</span>
              </div>
              <div v-if="item.differenceInOutNumbers">
                <b>{{ $t('outPhoneNumber') }}: </b>
                <span>{{ item.outNumber ? item.outNumber : $t('na') }}</span>
              </div>
              <div v-if="item.host && item.host.type && item.host.type === 'single'">
                <b>IP: </b>
                <span>{{ item.host.ip }}</span>
              </div>
              <template v-if="item.host && item.host.type && item.host.type === 'cluster'">
                <div v-if="item.host.routingNodes && item.host.routingNodes.find(n => n.default && n.weight > 0)">
                  <b>IP: </b>
                  {{
                    item.host.routingNodes ? item.host.routingNodes.find(n => n.default && n.weight > 0).publicIp : $t('notUpdated')
                  }}
                </div>
                <div
                    v-if="item.host.routingNodes && item.host.routingNodes.length && item.host.routingNodes.find(n => !n.default && n.weight > 0)">
                  <b>IP backup: </b>
                  {{
                    item.host.routingNodes && item.host.routingNodes.length ? item.host.routingNodes.filter(n => !n.default && n.weight > 0).map(i => i.publicIp).join(', ') : $t('notUpdated')
                  }}
                </div>
              </template>
              <div>
                <b>Port: </b>
                <span>5080</span>
              </div>
              <div v-if="item.desc">
                <b>{{ $t('desc') }}: </b>
                <span>{{ item.desc }}</span>
              </div>
              <div v-if="item.network">
                <b>{{ $t('network') }}: </b>
                <span>{{ item.network.name }}</span>
              </div>
              <div v-if="item.gateway">
                <b>{{ $t('gateway') }}: </b>
                <span>{{ item.gateway.name }}</span>
              </div>
              <div v-if="item.gateway">
                <b>Proxy: </b>
                <span>{{ item.gateway.proxy }}</span>
              </div>
            </div>
            <div class="col-lg-3">
              <div v-if="!item.client" class="text-danger">
                {{ $t('unowned') }}
              </div>
              <template v-else>
                <div>
                  <b>{{ $t('companyName') }}: </b>
                  <span>{{ item.client.companyName }}</span>
                </div>
                <div>
                  <b>Domain: </b>
                  <span>{{ item.client.domain }}</span>
                </div>
                <div>
                  <b>Host: </b>
                  <span>{{ item.client.host.ip }}</span>
                </div>
              </template>

              <div v-if="item.engagedTime">
                <b>{{ $t('engagedTime') }}: </b>{{ item.engagedTime | moment('DD/MM/YY HH:mm') }}
              </div>
              <div v-if="item.packageExpireTime">
                <b>{{ $t('packageExpireTime') }}: </b>{{ item.packageExpireTime | moment('DD/MM/YY HH:mm') }}
              </div>
              <div v-if="item.createdBy">
                <b>{{ $t('createdBy') }}: </b>{{ item.createdBy.name }}
              </div>
              <div v-if="item.updatedBy">
                <b>{{ $t('updatedBy') }}: </b>{{ item.updatedBy.name }}
              </div>
              <div v-if="item.createdBy">
                <b>{{ $t('createTime') }}: </b>{{ item.createTime | moment('DD/MM/YY HH:mm') }}
              </div>
              <div v-if="item.updatedBy">
                <b>{{ $t('updateTime') }}: </b>{{ item.updateTime | moment('DD/MM/YY HH:mm') }}
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label v-if="item.inbound"
                       class="badge badge-success mr-1">{{ $t('inboundEnabled') }}</label>
                <label v-if="!item.inbound"
                       class="badge badge-danger mr-1">{{ $t('inboundDisabled') }}</label>
                <label v-if="item.outbound"
                       class="badge badge-success mr-1">{{ $t('outboundEnabled') }}</label>
                <label v-if="!item.outbound" class="badge badge-danger mr-1">{{ $t('outboundDisabled') }}</label>
                <label v-if="item.isDemo" class="badge badge-info mr-1">{{ $t('isDemo') }}</label>
                <label v-if="item.isPackage" class="badge badge-primary mr-1">{{ $t(item.packageType) }}
                  ({{ item.packageExts ? item.packageExts.length : 0 }}/{{ item.packageLimit }})</label>
                <label v-if="item.isRental" class="badge badge-info mr-1">{{ $t('isRental') }}</label>
                <label v-if="item.isSpam" class="badge badge-danger mr-1">{{ $t('isSpam') }}</label>
                <label v-if="item.suspectedBlocked" class="badge badge-warning mr-1">{{ $t('suspectedBlocked')}}</label>
                <label v-if="item.isHidden" class="badge badge-warning mr-1">{{ $t('isHiddenInList') }}</label>
                <label v-if="item.privateFee" class="badge badge-info mr-1">{{ $t('privateFee') }}</label>
                <label v-if="item.isCommit" class="badge badge-secondary mr-1">{{ $t('isCommit') }}</label>
                <label v-if="item.skipSpamCheck" class="badge badge-warning mr-1">{{ $t('skipSpamCheck') }}</label>
              </div>
              <div><b>{{ $t('priority') }}:</b> {{ item.priority }}</div>
              <div v-if="item.errorMsg" class="text-danger"><b>{{ $t('error') }}:</b> {{ item.errorMsg }}</div>
              <div v-if="item.fixedRoutingIp"><b>{{ $t('fixedRoutingIp') }}:</b> {{ item.fixedRoutingIp }}</div>
              <div>
                ---------------------------
                <div><b>{{
                    $t('setupFee')
                  }}: </b>{{ item.privateFee ? item.setupFee : item.network.setupFee | numFormat }}
                </div>
                <div><b>{{
                    $t('monthlyFee')
                  }}: </b>{{ item.privateFee ? item.monthlyFee : item.network.monthlyFee | numFormat }}
                </div>
                <div><b>{{
                    $t('netCallFee')
                  }}: </b>{{ item.privateFee ? item.netCallFee : item.network.netCallFee | numFormat }}
                </div>
                <div><b>{{
                    $t('offnetCallFee')
                  }}: </b>{{ item.privateFee ? item.offnetCallFee : item.network.offnetCallFee | numFormat }}
                </div>
              </div>
              <div v-if="item.isBrandName">
                ---------------------------
                <div><b>{{ $t('brandName') }}: </b>{{ item.brandName }}</div>
                <div><b>{{ $t('brandNameSetupFee') }}: </b>{{ item.brandNameSetupFee | numFormat }}</div>
                <div><b>{{ $t('brandNameHotlineSetupFee') }}: </b>{{ item.brandNameHotlineSetupFee | numFormat }}</div>
                <div><b>{{
                    $t('brandNameMonthlyFee')
                  }}: </b>{{ item.brandNameMainNumber ? item.brandNameMonthlyFee : 0 | numFormat }}
                </div>
                <div v-if="item.brandNameMainNumber"><span class="badge badge-info">{{
                    $t('brandNameMainNumber')
                  }}</span></div>
              </div>
              <div v-if="item.isInboundCharge">
                ---------------------------
                <div><b>{{ $t('inboundCallFee') }}: </b>{{ item.inboundCallFee | numFormat }}</div>
                <div><b>{{ $t('inboundMinBillSecs') }}: </b>{{ item.inboundMinBillSecs | numFormat }}</div>
                <div><b>{{ $t('inboundBlockBillSecs') }}: </b>{{ item.inboundBlockBillSecs | numFormat }}</div>
              </div>
              <div v-if="item.fixedCallFee">
                ---------------------------
                <div><b>{{ $t('fixedCallFee') }}: </b>{{ item.fixedCallFee | numFormat }}</div>
              </div>
              <div v-if="item.isCommit">
                ---------------------------
                <div><b>{{ $t('commitMonthlyFee') }}: </b>{{ item.commitMonthlyFee | numFormat }}</div>
                <div><b>{{ $t('commitFromTime') }}: </b>{{ item.commitFromTime | moment('DD/MM/YYYY') }}</div>
                <div><b>{{ $t('commitToTime') }}: </b>{{ item.commitToTime | moment('DD/MM/YYYY') }}</div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button type="button" v-clipboard:copy="configInfo(item)" v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                            class="btn btn-sm btn-primary mr-1">
                      <font-awesome-icon icon="copy"/>&nbsp;{{ $t('copyConfig') }}
                    </button>
                    <button type="button" class="btn btn-sm btn-success mr-1" @click="clone(item)">
                      <font-awesome-icon icon="copy"/>&nbsp;{{ $t('clone') }}
                    </button>
                    <route v-if="item.client" :phone-number="item"></route>
                  </div>
                  <div class="c-buttons__col"
                       v-if="['owner', 'admin', 'tech', 'operationsManager', 'account', 'am'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            v-if="['owner', 'admin', 'tech', 'account'].includes($store.state.user.role) || ($store.state.user.role === 'am' && !item.isRental && item.client && $store.state.user._id === item.client.account)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                    <button
                        v-if="item.client && (['owner', 'admin', 'tech', 'account'].includes($store.state.user.role) || ($store.state.user.role === 'am' && !item.isRental && $store.state.user._id === item.client.account))"
                        @click="removeClient(item._id)" type="button"
                        class="btn btn-sm btn-warning mr-1">
                      <font-awesome-icon icon="window-close"/>&nbsp;{{ $t('removeClient') }}
                    </button>
                    <button v-if="!item.client" @click="getNumberInfo(item._id)" type="button"
                            class="btn btn-sm btn-success mr-1">
                      <font-awesome-icon icon="user"/>&nbsp;{{ $t('engageClient') }}
                    </button>
                  </div>
                  <update-ext v-if="item.isPackage && item.packageType==='monthlyUser'"
                              :phone-number-id="item._id"></update-ext>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" size="xl" @ok="save" no-close-on-backdrop no-enforce-focus>
      <template v-if="formModel.id">
        <label>{{ $t('client') }}:&nbsp;</label>
        <label v-if="formModel.client"><b>{{ formModel.client.companyName }} ({{ formModel.client.domain }})</b></label>
        <label v-else><span class="text-gray-999">{{ $t('noClientEngaged') }}</span></label>
      </template>
      <div class="row">
        <div class="col-md">
          <form-input class="mb-0" :label="$t('phoneNumber')" :model="formModel" attribute="number"
                      :errors="formErrors"></form-input>
          <div class="text-warning mb-3">
            <span v-if="existedNumbers.length && !formErrors.find(e => e.param === 'number')" class="small text-info">
              {{ $t('existedNumbersNote', [existedNumbers.length, formModel.number]) }}
            </span>
          </div>
          <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
          <form-checkbox :chk-label="$t('differenceInOutNumbers')" :model="formModel"
                         attribute="differenceInOutNumbers" :errors="formErrors"></form-checkbox>
          <form-input v-if="formModel.differenceInOutNumbers" :label="$t('outPhoneNumber')" :model="formModel"
                      attribute="outNumber" :errors="formErrors">
          </form-input>
          <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-input>
          <country-select :model="formModel" :errors="formErrors"></country-select>
          <network-select :model="formModel" countryAttribute="country" :disabled="!formModel.country"
                          :errors="formErrors"></network-select>
          <host-select :model="formModel" countryAttribute="country" type="number" :disabled="!formModel.country"
                       :errors="formErrors"></host-select>
          <gateway-select :model="formModel" :disabled="!formModel.country" :errors="formErrors"></gateway-select>
          <form-checkbox :model="formModel" attribute="isFixedRoutingIp" :errors="formErrors"
                         :chk-label="$t('isFixedRoutingIp')"></form-checkbox>
          <form-input v-if="formModel.isFixedRoutingIp" :label="$t('fixedRoutingIp')" :model="formModel"
                      attribute="fixedRoutingIp" :errors="formErrors"></form-input>
          <form-input :label="$t('priority')" :model="formModel"
                      attribute="priority" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental" :label="$t('fixedCallFee')" :model="formModel" attribute="fixedCallFee"
                      :errors="formErrors"></form-input>

          <form-checkbox :chk-label="$t('inbound')" :model="formModel" attribute="inbound" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('outbound')" :model="formModel" attribute="outbound" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isDemo')" :model="formModel" attribute="isDemo" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isRental')" :model="formModel" attribute="isRental" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isSpam')" :model="formModel" attribute="isSpam" :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('suspectedBlocked')" :model="formModel" attribute="suspectedBlocked"
                         :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isHidden')" :model="formModel" attribute="isHidden" :errors="formErrors" />
          <form-checkbox :chk-label="$t('skipSpamCheck')" :model="formModel" attribute="skipSpamCheck" :errors="formErrors" />
        </div>
        <div class="col-3" v-if="formModel.isRental">
          <form-checkbox v-if="formModel.isRental" :chk-label="$t('privateFee')" :model="formModel"
                         attribute="privateFee" :errors="formErrors"></form-checkbox>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('setupFee')" :model="formModel"
                      attribute="setupFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('monthlyFee')" :model="formModel"
                      attribute="monthlyFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('netCallFee')" :model="formModel"
                      attribute="netCallFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('offnetCallFee')"
                      :model="formModel" attribute="offnetCallFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('minBillSecs')" :model="formModel"
                      attribute="minBillSecs" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.privateFee" :label="$t('blockBillSecs')"
                      :model="formModel" attribute="blockBillSecs" :errors="formErrors"></form-input>

          <form-checkbox :chk-label="$t('isInboundCharge')" :model="formModel" attribute="isInboundCharge"
                         :errors="formErrors"/>
          <form-input v-if="formModel.isInboundCharge" :label="$t('inboundCallFee')" :model="formModel"
                      attribute="inboundCallFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isInboundCharge" :label="$t('inboundMinBillSecs')" :model="formModel"
                      attribute="inboundMinBillSecs" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isInboundCharge" :label="$t('inboundBlockBillSecs')" :model="formModel"
                      attribute="inboundBlockBillSecs" :errors="formErrors"></form-input>
        </div>
        <div class="col-3">
          <form-checkbox :chk-label="$t('isCommit')" :model="formModel" attribute="isCommit" :errors="formErrors"/>
          <form-input v-if="formModel.isCommit" :label="$t('commitMonthlyFee')" :model="formModel"
                      attribute="commitMonthlyFee" :errors="formErrors"></form-input>
          <form-date-time format="DD/MM/YYYY" v-if="formModel.isCommit" :label="$t('commitFromTime')" :model="formModel"
                          attribute="commitFromTime" :errors="formErrors"></form-date-time>
          <form-date-time format="DD/MM/YYYY" v-if="formModel.isCommit" :label="$t('commitToTime')" :model="formModel"
                          attribute="commitToTime" :errors="formErrors"></form-date-time>
          <div v-if="formModel.isCommit" class="alert alert-warning">
            Lưu ý: Hạn cam kết sẽ tự động đổi thành ngày cuối cùng của tháng
          </div>
          <form-checkbox :chk-label="$t('isBrandName')" :model="formModel" attribute="isBrandName"
                         :errors="formErrors"/>
          <form-input v-if="formModel.isBrandName" :label="$t('brandName')" :model="formModel" attribute="brandName"
                      :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.isBrandName" :label="$t('brandNameSetupFee')"
                      :model="formModel" attribute="brandNameSetupFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.isBrandName" :label="$t('brandNameHotlineSetupFee')"
                      :model="formModel" attribute="brandNameHotlineSetupFee" :errors="formErrors"></form-input>
          <form-input v-if="formModel.isRental && formModel.isBrandName" :disabled="!formModel.brandNameMainNumber"
                      :label="$t('brandNameMonthlyFee')" :model="formModel" attribute="brandNameMonthlyFee"
                      :errors="formErrors"></form-input>
          <form-checkbox v-if="formModel.isBrandName" :chk-label="$t('brandNameMainNumber')" :model="formModel"
                         attribute="brandNameMainNumber" :errors="formErrors"/>
          <div v-if="formModel.isBrandName" class="alert alert-warning">
            Lưu ý: Chỉ thu phí duy trì định danh/tháng với số hotline chính gắn với định danh
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="engageForm" :title="$t('engageClient')" @ok="engageClient(engageFormModel.id)">
      <div class="row">
        <div class="col-md">
          <div><b>{{ $t('number') }}</b>: <span>{{ engageFormModel.number }}</span></div>
          <div>
            <b>{{ $t('isDemo') }}: </b>
            <label v-if="engageFormModel.isDemo" class="badge badge-primary mb-0">{{ $t('yes') }}</label>
            <label v-else class="badge badge-secondary mb-0">{{ $t('no') }}</label>
          </div>
          <div>
            <b>{{ $t('isRental') }}: </b>
            <label v-if="engageFormModel.isRental" class="badge badge-primary mb-0">{{ $t('yes') }}</label>
            <label v-else class="badge badge-secondary mb-0">{{ $t('no') }}</label>
          </div>
          <div>
            <b>{{ $t('privateFee') }}: </b>
            <label v-if="engageFormModel.privateFee" class="badge badge-primary mb-0">{{ $t('yes') }}</label>
            <label v-else class="badge badge-secondary mb-0">{{ $t('no') }}</label>
          </div>
        </div>
        <div class="col-md">
          <div v-if="engageFormModel.populatedNetwork"><b>{{ $t('network') }}</b>:
            <span>{{ engageFormModel.populatedNetwork.name }}</span></div>
          <template v-if="engageFormModel.isRental && engageFormModel.network">
            <div>
              <b>{{ $t('setupFee') }}: </b>
              <span>{{
                  engageFormModel.privateFee ? engageFormModel.setupFee : engageFormModel.populatedNetwork.setupFee | numFormat
                }}</span>
            </div>
            <div>
              <b>{{ $t('monthlyFee') }}: </b>
              <span>{{
                  engageFormModel.privateFee ? engageFormModel.monthlyFee : engageFormModel.populatedNetwork.monthlyFee | numFormat
                }}</span>
            </div>
            <div>
              <b>{{ $t('netCallFee') }}: </b>
              <span>{{
                  engageFormModel.privateFee ? engageFormModel.netCallFee : engageFormModel.populatedNetwork.netCallFee | numFormat
                }}</span>
            </div>
            <div>
              <b>{{ $t('offnetCallFee') }}: </b>
              <span>{{
                  engageFormModel.privateFee ? engageFormModel.offnetCallFee : engageFormModel.populatedNetwork.offnetCallFee | numFormat
                }}</span>
            </div>
          </template>
        </div>
      </div>
      <client-select class=" mt-2" :model="engageFormModel" attribute="client" :errors="engageFormErrors"/>
      <div v-if="plan" class="alert" :class="[plan.count >= plan.limit ? 'alert-danger' :'alert-warning']">
        Cài đặt định tuyến được cài đặt tối đa {{ plan.count | numFormat }}/{{ plan.limit | numFormat }} số điện thoại
      </div>
      <div class="alert alert-info" v-if="engageFormModel.isRental && !engageFormModel.isDemo">{{ $t('engageNote') }}
      </div>
    </b-modal>
    <b-modal v-model="showDelete" no-close-on-backdrop scrollable :title="$t('massDelete')" size="lg">
      <p>{{ $t('numberListToDelete') }}</p>
      <div class="c-template-table table-responsive mb-0">
        <table class="table table-bordered table-more table-hover">
          <thead>
          <tr>
            <th class="text-center">#</th>
            <th>{{ $t('phone') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in checkedItems" :key="data._id">
            <td class="text-center">{{ index + 1 }}</td>
            <td>
              <span>{{ $t(data.number) }} </span>
              <span v-if="data.network"> - {{ data.network.name }}</span>
            </td>
            <td>
              <span :for="`result_${data._id}`"></span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showDelete = false">
          {{ $t('cancel') }}
        </b-button>
        <b-button :disabled="deleteLoading" variant="primary" class="float-right" @click="startDelete">
          <b-spinner v-if="deleteLoading" small></b-spinner>
          {{ $t('delete') }}
        </b-button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import $ from 'jquery';
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import HostSelect from "../../components/HostSelect";
import GatewaySelect from "../../components/GatewaySelect";
import ClientSelect from "../../components/ClientSelect";
import NetworkSelect from "../../components/NetworkSelect";
import CountrySelect from "../../components/CountrySelect";
import TableConfig from "../../components/TableConfig.vue";
import _ from 'lodash';
import UpdateExt from "./UpdateExt";
import Export from "./NumberExport";
import Import from "./NumberImport";
import CheckPhoneNumber from "./CheckPhoneNumber";
import Route from "./Route";

export default {
  props: {
    host: Object,
    client: Object,
    numbersToCheck: Array,
    hiddenCSortingFeature: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TableConfig,
    UpdateExt,
    NetworkSelect,
    ClientSelect,
    GatewaySelect,
    HostSelect,
    CountrySelect,
    Export,
    Import,
    CheckPhoneNumber,
    Route
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/phone-number',
      afterLoad: () => {
        this.getCount();
      },
      reloadBus: 'phoneNumber',
      defaultFormModel: {
        number: null,
        country: null,
        client: this.client ? this.client._id : null,
        host: this.host ? this.host._id : null,
        backupHost: null,
        gateway: null,
        differenceInOutNumbers: false,
        inbound: true,
        outbound: true,
        isRental: false,
        privateFee: false,
        priority: 1,
        isFixedRoutingIp: false,
        fixedRoutingIp: null,
        isSpam: false,
        suspectedBlocked: false,
        isHidden: false,
        isCommit: false,
        commitFromTime: Date.now(),
        commitToTime: null,
        commitMonthlyFee: null,
        isBrandName: false,
        isInboundCharge: false,
        brandNameMainNumber: false,
        brandName: null,
        brandNameSetupFee: null,
        brandNameMonthlyFee: null,
        brandNameHotlineSetupFee: null,
      },
      defaultFilterFormModel: {
        keyword: null,
        type: null,
        network: null,
        client: this.client ? this.client._id : null,
        host: this.host ? this.host._id : null,
        gateway: null,
        numbersToCheck: this.numbersToCheck && this.numbersToCheck.length ? this.numbersToCheck : null,
      },
      engageForm: false,
      engageFormModel: {},
      engageFormErrors: [],
      hosts: [],
      currentHost: null,
      isFixedRoutingIp: false,
      existedNumbers: [],
      count: {},
      countLoading: false,
      showDelete: false,
      deleteLoading: false,
      selectAll: false,
      checkedItems: [],
      plan: null,
      firstItemOfPage: 0,
      lastItemOfPage: 0,
    }
  },
  watch: {
    "formModel.number": _.debounce(function (val) {
      this.existedNumbers = [];
      if (val && !this.formModel._id) {
        this.$service.get(this.service, {params: {number: val.trim(), page: 1, pageSize: 50}})
            .then(response => {
              if (response && response.data && response.data.docs) {
                this.existedNumbers = response.data.docs;
              }
            })
      }
    }, 200),
    "formModel.host": {
      handler(val) {
        let host = this.hosts.find(host => host._id == val);
        if (host && host.type === 'routing') {
          this.currentHost = host;
        } else {
          this.currentHost = null;
        }
      }, deep: true
    },
    "formModel.isRental": function (val) {
      if (!val) {
        this.formModel.privateFee = null;
        this.formModel.isInboundCharge = null;
      }
    },
    "formModel.privateFee": function (val) {
      if (!val) {
        this.formModel.setupFee = null;
        this.formModel.monthlyFee = null;
        this.formModel.netCallFee = null;
        this.formModel.offnetCallFee = null;
        this.formModel.minBillSecs = null;
        this.formModel.blockBillSecs = null;
      }
    },
    "formModel.isInboundCharge": function (val) {
      if (!val) {
        this.formModel.inboundCallFee = null;
        this.formModel.inboundMinBillSecs = null;
        this.formModel.inboundBlockBillSecs = null;
      }
    },
    "formModel.isBrandName": function (val) {
      if (!val) {
        this.formModel.brandName = null;
        this.formModel.brandNameSetupFee = null;
        this.formModel.brandNameHotlineSetupFee = null;
        this.formModel.brandNameMainNumber = null;
      }
    },
    "formModel.brandNameMainNumber": function (val) {
      if (!val) {
        this.formModel.brandNameMonthlyFee = null;
      }
    },
    "formModel.isCommit": function (val) {
      if (!val) {
        this.formModel.commitMonthlyFee = null;
        this.formModel.commitToTime = null;
      }
    },
    "engageFormModel.client": function (val) {
      this.plan = null;
      if (val) {
        let loader = this.$loading.show();
        this.$service.get(this.service + '/quota/' + val).then(response => {
          if (response.data) {
            this.plan = response.data;
          }
        }).finally(() => {
          loader.hide();
        });
      }
    },
    "formModel.isSpam": function (val) {
      if (!val) {
        this.formModel.suspectedBlocked = false
      }
    },
  },
  i18n: {
    messages: {
      en: {
        title: 'Phone numbers list',
        all: 'All',
        clientOwned: 'Client owned',
        isDemo: 'Demo number',
        removeClient: "Remove client",
        unowned: "Unowned",
        removeClientMsg: "Are you sure to remove client from this number?",
        isRental: "Rental number",
        availableForRent: "Available for rent",
        privateFee: "Private fee",
        setupFee: 'Setup fee',
        monthlyFee: 'Monthly fee',
        netCallFee: 'In network call fee',
        offnetCallFee: 'Off network call fee',
        minBillSecs: 'Minimum bill seconds',
        blockBillSecs: 'Block bill seconds',
        inboundEnabled: 'Inbound enabled',
        inboundDisabled: 'Inbound disabled',
        outboundEnabled: 'Outbound enabled',
        outboundDisabled: 'Outbound disabled',
        differenceInOutGateways: 'Difference In/Out gateways',
        differenceInOutNumbers: 'Difference In/Out numbers',
        outPhoneNumber: 'Outbound number',
        outGateway: 'Outbound gateway',
        outGatewayProxy: 'Proxy outbound gọi ra',
        chooseGateway: 'Choose gateway',
        noClientEngaged: 'No client engaged',
        number: 'Number',
        yes: 'Yes',
        no: 'No',
        engageClient: 'Engage client',
        engageNote: 'Note: If the set up fee is greater than 0, he client will be charged immediately after this number is engaged to them. Please double check all the information before press OK',
        monthlyUserPackage: 'Monthly user',
        monthlyUser: 'TGU',
        monthlyChannel: 'TGC',
        packageExpireTime: 'Package expire time',
        engagedTime: 'Engaged time',
        priority: 'Priority',
        copyConfig: 'Copy config',
        infoCopied: 'Config info copied!',
        backupHost: "Backup Host",
        isFixedRoutingIp: 'Use fixed routing IP',
        fixedRoutingIp: 'Fixed routing IP',
        isSpam: "Spam blocked number",
        isBrandName: "Use brandName",
        brandName: "BrandName",
        isInboundCharge: "Inbound Calling Charge",
        inboundCallFee: "Inbound Call Fee",
        inboundMinBillSecs: "Minimum billing seconds when calling in",
        inboundBlockBillSecs: "Number of seconds/blocks when calling in",
        fixedCallFee: "Fixed/call charges",
        brandNameSetupFee: "Phí đăng ký tên định danh",
        brandNameHotlineSetupFee: "Phí gán tên định danh vào hotline",
        brandNameMonthlyFee: "Phí duy trì tên định danh/Tháng",
        brandNameMainNumber: "Số hotline chính gắn với định danh",
        isCommit: "Số cam kết",
        commitToTime: "Cam kết đến",
        commitFromTime: "Cam kết từ",
        commitMonthlyFee: "Cước gọi tối thiểu / tháng",
        existingNumbersNote: "Note: already exists {0} phone number {1} on the system",
        createdBy: "Created by",
        updatedBy: "Updated by",
        cloneNumber: "Clone number",
        clone: "Clone",
        selected: "Selected {0}",
        massDelete: "Mass delete",
        numberListToDelete: "To delete numbers",
        isHidden: "Hide phone number in call list",
        isHiddenInList: "Hide in call list",
        numberRandom: "Random number",
        numberHidden: "Number hidden in call list",
        suspectedBlocked: "Suspected call blocking",
        phoneNumbers: 'result(s)',
        skipSpamCheck: 'Skip spam check',
      },
      vi: {
        title: 'Danh sách số điện thoại',
        all: 'Tất cả',
        clientOwned: 'Số của khách',
        isDemo: 'Số demo',
        removeClient: "Gỡ khách hàng",
        unowned: "Vô chủ",
        removeClientMsg: "Bạn chắc chắn muốn gỡ khách hàng khỏi số điện thoại này?",
        isRental: "Số cho thuê",
        availableForRent: "Số chưa được thuê",
        privateFee: "Bảng phí riêng",
        setupFee: 'Phí cài đặt',
        monthlyFee: 'Phí hàng tháng',
        netCallFee: 'Phí gọi nội mạng',
        offnetCallFee: 'Phí gọi ngoại mạng',
        minBillSecs: 'Số giây tính cước tối thiểu',
        blockBillSecs: 'Số giây / block tính cước',
        inboundEnabled: 'Được gọi vào',
        inboundDisabled: 'Chặn gọi vào',
        outboundEnabled: 'Được gọi ra',
        outboundDisabled: 'Chặn gọi ra',
        differenceInOutGateways: 'Gọi ra / gọi vào khác gateway',
        outGateway: 'Gateway gọi ra',
        outGatewayProxy: 'Proxy gateway gọi ra',
        differenceInOutNumbers: 'Gọi ra / gọi vào khác số',
        outPhoneNumber: 'Số gọi ra',
        chooseGateway: 'Chọn gateway',
        noClientEngaged: 'Chưa gắn cho khách hàng nào',
        number: 'Số',
        yes: 'Có',
        no: 'Không',
        engageClient: 'Gắn khách hàng',
        engageNote: 'Lưu ý: Nếu phí cài đặt lớn hơn 0, khách hàng sẽ bị trừ tiền cài đặt ngay sau khi số điện thoại này được gắn. Kiểm tra kỹ tất cả các thông tin trước khi nhấn OK',
        monthlyUserPackage: 'Trọn gói',
        monthlyUser: 'TGU',
        monthlyChannel: 'TGC',
        packageExpireTime: 'Hết hạn lúc',
        engagedTime: 'Gắn client lúc',
        priority: 'Thứ tự ưu tiên',
        copyConfig: 'Sao chép cấu hình',
        infoCopied: 'Thông tin cấu hình đã được sao chép!',
        backupHost: "Tổng đài backup",
        isFixedRoutingIp: 'Sử dụng IP routing cố định',
        fixedRoutingIp: 'IP routing cố định',
        isSpam: "Số bị chặn spam",
        isBrandName: "Sử dụng tên định danh",
        brandName: "Tên dịnh danh",
        isInboundCharge: "Tính phí gọi vào",
        inboundCallFee: "Phí gọi vào",
        inboundMinBillSecs: "Số giây tính cước tối thiểu khi gọi vào",
        inboundBlockBillSecs: "Số giây / block tính cước khi gọi vào",
        fixedCallFee: "Thu phí cố định/ cuộc gọi",
        brandNameSetupFee: "Phí đăng ký tên định danh",
        brandNameHotlineSetupFee: "Phí gán tên định danh vào hotline",
        brandNameMonthlyFee: "Phí duy trì tên định danh/Tháng",
        brandNameMainNumber: "Số hotline chính gắn với định danh",
        isCommit: "Số cam kết",
        commitToTime: "Cam kết đến",
        commitFromTime: "Cam kết từ",
        commitMonthlyFee: "Cước gọi tối thiểu / tháng",
        existedNumbersNote: "Lưu ý: đã tồn tại {0} số điện thoại {1} trên hệ thống",
        createdBy: "Tạo bởi",
        updatedBy: "Cập nhật bởi",
        cloneNumber: "Sao chép số điện thoại",
        clone: "Sao chép",
        selected: "Đã chọn {0}",
        massDelete: "Xoá hàng loạt",
        numberListToDelete: "Danh sách số sẽ bị xoá",
        isHidden: "Ẩn số điện thoại ở danh sách gọi",
        isHiddenInList: "Ẩn ở danh sách gọi",
        numberRandom: "Số ngẫu nhiên",
        numberHidden: "Số bị ẩn ở danh sách gọi",
        suspectedBlocked: "Nghi ngờ bị chặn gọi",
        phoneNumbers: 'kết quả',
        skipSpamCheck: 'Bỏ qua kiểm tra spam',
      }
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    removeClient: function (id) {
      this.$swal({
        title: this.$t('removeClientMsg'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/remove-client/' + id).then(response => {
            if (response.data) {
              if (this.load) {
                this.load();
              }
              this.$swal({
                title: this.$t('success'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    engageClient: function (id) {
      let loader = this.$loading.show();
      this.$service({
        url: this.service + '/engage-client/' + id,
        method: 'put',
        data: this.engageFormModel
      }).then(response => {
        if (response.data) {
          if (this.load) {
            this.load();
          }
          this.$swal({
            title: this.$t('success'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.engageFormErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    update: function (id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        response.data.brandNameMainNumber = response.data.brandNameMainNumber ? response.data.brandNameMainNumber : false;
        this.$service.get('/host/' + response.data.host).then(responseHost => {
          this.formModel = {};
          this.formTitle = this.$t('update');
          this.formErrors = [];
          this.showForm = true;
          this.formModel = response.data;
          this.formModel.id = id;
          if (responseHost.data) {
            this.formModel.country = responseHost.data.country;
          }
        });
      }).finally(() => {
        loader.hide();
      });
    },
    clone(item) {
      this.create();
      this.formTitle = this.$t('cloneNumber');
      this.formModel = _.cloneDeep(item);
      this.formModel.client = null;
      this.formModel.number = null;
      this.formModel.country = item.host ? item.host.country : null;
      this.formModel.host = item.host ? item.host._id : null;
      this.formModel.gateway = item.gateway ? item.gateway._id : null;
      this.formModel.network = item.network ? item.network._id : null;
      this.formModel.host = item.host ? item.host._id : null;
      delete this.formModel._id;
    },
    getNumberInfo: function (id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        this.engageFormModel = {};
        this.engageFormErrors = [];
        this.engageForm = true;
        this.engageFormModel = response.data;
        this.engageFormModel.id = id;
      }).finally(() => {
        loader.hide();
      });
    },
    configInfo(item) {
      let result = `Số điện thoại: ${item.number}\n`;
      if (item.differenceInOutNumbers && item.outNumber) {
        result += `Số gọi ra: ${item.outNumber}\n`
      }
      let mainIp;
      if (item.host && item.host.type && item.host.type === 'single') {
        mainIp = item.host.ip
      }
      if (item.host && item.host.type && item.host.type === 'cluster') {
        if (item.host.routingNodes && item.host.routingNodes.length) {
          mainIp = item.host.routingNodes.find(n => n.default).publicIp
        }
      }
      result += `IP chính: ${mainIp}\n`;
      if (item.host && item.host.type && item.host.type === 'cluster') {
        let backupIps;
        if (item.host.routingNodes && item.host.routingNodes.length) {
          backupIps = item.host.routingNodes
              .filter(n => !n.default)
              .map(i => i.publicIp)
              .join(', ');
          result += `IP dự phòng: ${backupIps}\n`;
        }
      }
      result += `Port: 5080\n`;
      result += '-----------------------------------------\n';
      result += `IP của NCC dịch vụ: ${item.gateway.proxy}\n`;
      return result;
    },
    onCopy() {
      this.$swal({
        text: this.$t('infoCopied'),
        icon: 'success',
        toast: true,
        position: 'top-end',
        timer: 5000,
      });
    },
    onError() {
      this.$swal({
        title: this.$t('error'),
        text: this.$t('copyFailed'),
        icon: 'error'
      });
    },
    getCount() {
      this.countLoading = true
      this.$service.get(this.service + '/count', {params: this.filterFormModel})
          .then(response => {
            this.count = response.data;
          })
          .catch(() => {
            this.count = {};
          })
          .finally(() => {
            this.countLoading = false;
          });
    },
    async startDelete() {
      this.deleteLoading = true;
      let i = 0;
      let successCount = 0;
      $(`span[for^=result]`).html('<div class="spinner-border spinner-border-sm text-primary" role="status"><span class="sr-only">Loading...</span></div>');

      while (this.showDelete && i < this.checkedItems.length) {
        let data = this.checkedItems[i];
        i++;
        try {
          let response;
          response = await this.$bgService.delete(this.service + '/' + data._id);
          if (response) {
            successCount++;
            $(`span[for=result_${data._id}]`).html(`<span class="badge badge-success">${this.$t('success')}</span>`);
          } else {
            $(`span[for=result_${data._id}]`).html(`<span class="badge badge-danger">${this.$t('fail')}</span>`);
          }
        } catch (e) {
          $(`span[for=result_${data._id}]`).html(`<span class="text-danger">${e.response.data.message}</span>`);
        }
      }
      if (successCount === this.checkedItems.length) {
        this.showMassUpdateModel = false;
        this.$swal({
          title: this.$t('success'),
          text: this.$t('deleted'),
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        })
      }
      this.showDelete = false;
      this.deleteLoading = false;
      this.selectAll = false;
      this.checkedItems = [];
      this.load();

    },
    select() {
      this.checkedItems = [];
      if (this.selectAll) {
        this.items.forEach((item, index) => {
          this.checkedItems.push(this.items[index]);
        });
      }
    },
    updateCheckAll() {
      this.selectAll = this.items.length === this.checkedItems.length;
    },
    apply: function (data) {
      this.items = data.docs;
      this.itemCount = data.totalDocs;
      this.firstItemOfPage = this.itemCount > 0 ? (this.filterFormModel.page - 1) * this.filterFormModel.pageSize + 1 : 0;
      this.lastItemOfPage = (this.filterFormModel.page - 1) * this.filterFormModel.pageSize + this.items.length;
    },
    loadTableConfig(config) {
      if (config && config.pageSize) {
        this.defaultFilterFormModel.pageSize = config.pageSize;
        this.filterFormModel.pageSize = config.pageSize;
        this.filterFormModel.page = 1;
      }
      this.load();
    },
  },
  mounted() {
    this.filterFormModel = {};
    this.filterFormModel = Object.assign({}, this.filterFormModel, this.defaultFilterFormModel);
    if (this.$route.query && this.$route.query.keyword) {
      this.filterFormModel.keyword = this.$route.query.keyword;
    }

    this.$bgService.get('/host', {params: {page: 1, pageSize: 1000}}).then(response => {
      this.hosts = response.data.docs;
    });
  },
};
</script>
<style>
.check-column {
  position: relative;
}

.check-form {
  position: absolute;
  top: 0;
  right: 0;
}

.check-form.hide {
  display: none;
}

.check-row:hover .check-form {
  display: block;
}
</style>